/* eslint-disable-file no- */
import moment from 'moment'
import { translate, defaultLocale } from '@/libs/translate'

export const unicodeLiLu =
  /[A-Za-zªµºÀ-ÖØ-öø-ƺƼ-ƿǄǆ-Ǉǉ-Ǌǌ-Ǳǳ-ʓʕ-ʯͰ-ͳͶ-ͷͻ-ͽΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԣԱ-Ֆա-ևႠ-Ⴥᴀ-ᴫᵢ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶ-Άιῂ-ῄῆ-Ήῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-Ώⁱⁿℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃ-ↄⰀ-Ⱞⰰ-ⱞⱠ-Ɐⱱ-ⱼⲀ-ⳤⴀ-ⴥꙀ-ꙟꙢ-ꙭꚀ-ꚗꜢ-ꝯꝱ-ꞇꞋ-ꞌﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ]|\ud801[\udc00-\udc4f]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]/
export const unicodeLu =
  /[A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸ-ŹŻŽƁ-ƂƄƆ-ƇƉ-ƋƎ-ƑƓ-ƔƖ-ƘƜ-ƝƟ-ƠƢƤƦ-ƧƩƬƮ-ƯƱ-ƳƵƷ-ƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺ-ȻȽ-ȾɁɃ-ɆɈɊɌɎͰͲͶΆΈ-ΊΌΎ-ΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹ-ϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀ-ӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԱ-ՖႠ-ჅḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾ-ℿⅅↃⰀ-ⰮⱠⱢ-ⱤⱧⱩⱫⱭ-ⱯⱲⱵⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽ-ꝾꞀꞂꞄꞆꞋＡ-Ｚ]|\ud801[\udc00-\udc27]|\ud835[\udc00-\udc19\udc34-\udc4d\udc68-\udc81\udc9c\udc9e-\udc9f\udca2\udca5-\udca6\udca9-\udcac\udcae-\udcb5\udcd0-\udce9\udd04-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd38-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd6c-\udd85\udda0-\uddb9\uddd4-\udded\ude08-\ude21\ude3c-\ude55\ude70-\ude89\udea8-\udec0\udee2-\udefa\udf1c-\udf34\udf56-\udf6e\udf90-\udfa8\udfca]/
// eslint-disable-next-line no-control-regex
export const unicodeLatin = /[\u0000-~\u0080-þĀ-žƀ-ɎḀ-Ỿ]/

export const insz = /^$|^([0-9]{9})([0-9]{2})$/

export const regularExpression = (value: string, regex: RegExp, errorMessage: string): string => {
  if (!regex.test(value)) {
    return errorMessage
  } else {
    return null
  }
}

export const textMiddle = (value: string) => textMiddleByLocale(value)

export const textMiddleByLocale = (value: string, locale: string = defaultLocale) => {
  const checkList = [
    () => {
      if (!value || !value.trim().length) {
        return translate('general.validation.lengthMustBeLargerThanZero', locale)
      }
      return null
    },
    () => {
      // eslint-disable-next-line
      const match = /[^&\(\),\.\/'\-0-9\u0000-~\u0080-þĀ-žƀ-ɎḀ-Ỿ\s]+/i.exec(value) // Latin
      if (match) {
        return translate('general.validation.containsNotAllowedCharacters', locale)
      }
      return null
    },
    () => {
      const match = /[a-zA-Z]/.exec(value)
      if (!match) {
        return translate('general.validation.mustContainALetter', locale)
      }
      return null
    },
    () => {
      const match = /\s{2,}/.exec(value)
      if (match) {
        return translate('general.validation.noConsecutiveSpaces', locale)
      }
      return null
    },
  ]

  let error = ''
  for (const validation of checkList) {
    error = validation()
    if (error) {
      break
    }
  }
  return error
}

export const sanitizedInput = (value: string) => sanitizedInputByLocale(value)

export const sanitizedInputByLocale = (value: string, locale: string = defaultLocale) => {
  const meta_chars = ['+', '"', '<', '>', ';', '/', '(', ')']
  if (meta_chars.some((x) => value.includes(x))) {
    value = sanitizeInput(value)
  }

  const checkList = [
    () => {
      if (!value || !value.trim().length) {
        return translate('general.validation.lengthMustBeLargerThanZero', locale)
      }
      return null
    },
  ]

  let error = ''
  for (const validation of checkList) {
    error = validation()
    if (error) {
      break
    }
  }
  return error
}

export const textStrict = (value: string) => textStrictByLocale(value)

export const textStrictByLocale = (value: string, locale: string = defaultLocale) => {
  const textMiddleResponse = textMiddleByLocale(value, locale)
  if (!textMiddleResponse) {
    const checkList = [
      () => {
        const match = /[0-9]+/.exec(value)
        if (match) {
          return translate('general.validation.containsNumbers', locale)
        }
        return null
      },
      () => {
        const match = /\.{2,}/.exec(value)
        if (match) {
          return translate('general.validation.noConsecutiveDots', locale)
        }
        return null
      },
      () => {
        // eslint-disable-next-line
        const match = /([&\(\),\.\/'\-])\1{3,}/.exec(value)
        if (match) {
          return translate('general.validation.noConsecutiveCharacters', locale)
        }
        return null
      },
    ]

    let error = ''
    for (const validation of checkList) {
      error = validation()
      if (error) {
        break
      }
    }
    return error
  }
  return textMiddleResponse
}

export const isInszError = (value: string): string => {
  const strippedValue = (!value ? '' : value).match(/\d+/g)
  if (strippedValue) {
    const match = /^$|^([0-9]{9})([0-9]{2})$/.exec((!value ? '' : value).match(/\d+/g).join(''))
    if (match) {
      const input = parseInt(match[1], 10)
      const control = parseInt(match[2], 10)
      if (97 - (input % 97) !== control && 97 - ((2000000000 + input) % 97) !== control) {
        return 'Het controlegetal klopt niet'
      }
      return null
    } else {
      return 'Gelieve een geldig insz nummer op te geven'
    }
  } else {
    return 'Gelieve een geldig insz nummer op te geven'
  }
}

export const isInszErrorByLocale = (value: string, locale: string = defaultLocale): string => {
  const strippedValue = (!value ? '' : value).match(/\d+/g)
  if (strippedValue) {
    const match = /^$|^([0-9]{9})([0-9]{2})$/.exec((!value ? '' : value).match(/\d+/g).join(''))
    if (match) {
      const input = parseInt(match[1], 10)
      const control = parseInt(match[2], 10)
      if (97 - (input % 97) !== control && 97 - ((2000000000 + input) % 97) !== control) {
        return translate('general.validation.controlNumberSSIN', locale)
      }
      return null
    } else {
      return translate('general.validation.validSSIN', locale)
    }
  } else {
    return translate('general.validation.validSSIN', locale)
  }
}

export const isCorrectCTPC = (value: string, locale: string = defaultLocale): string => {
  if (value && value.length !== 16) {
    return translate('healthAttestations.error.ctpcError', locale)
  } else return null
}

export const isKBOError = (value: string): string => {
  const strippedValue = (!value ? '' : value).match(/\d+/g)
  if (strippedValue) {
    const match = /^$|^([0-9]{8})([0-9]{2})$/.exec((!value ? '' : value).match(/\d+/g).join(''))
    if (match) {
      const input = parseInt(match[1], 10)
      const control = parseInt(match[2], 10)
      if (97 - (input % 97) !== control) {
        return 'Het controlegetal klopt niet'
      }
      return null
    } else {
      return 'Gelieve een geldig KBO nummer op te geven'
    }
  } else {
    return 'Gelieve een geldig KBO nummer op te geven'
  }
}

export const isStructuredCommunicationError = (value: string): string => {
  const match = /([0-9]{3})[/]([0-9]{4})[/]([0-9]{3})([0-9]{2})/g.exec((!value ? '' : value).match(/\d+/g).join('/'))
  if (match) {
    const input = parseInt(match[1] + match[2] + match[3], 10)
    const control = parseInt(match[4], 10)
    if (input % 97 !== control) {
      return 'Het controlegetal klopt niet'
    }
    return null
  } else {
    return 'Gelieve een geldige gestructureerde mededeling op te geven'
  }
}

export const isIBANError = (value: string): string => {
  /* https://nl.wikipedia.org/wiki/International_Bank_Account_Number */
  const match = !!value && value.match(/^[a-zA-Z0-9 ]+$/)
  if (match) {
    const iban = value.toUpperCase().replace(/[^A-Z0-9]/g, '')
    const minimulLengthIban = 15

    if (iban.length >= minimulLengthIban) {
      const digits = parseInt(iban.substring(2, 4), 10)
      const bank = iban.substring(4, iban.length) + iban.substring(0, 4)
      const asciiShift = 55

      let checkSumString = ''
      for (let i = 0; i < bank.length; i++) {
        const c = bank[i]
        let character
        if (c.match(/^[A-Z]+$/)) {
          character = c.charCodeAt(0) - asciiShift
        } else {
          character = parseInt(c)
        }
        checkSumString += character.toString()
      }

      const digitsAreOk = !isNaN(digits) && digits >= 2 && digits <= 98

      if (mod97(checkSumString) == 1 && digitsAreOk) {
        return null
      } else {
        return 'Het controlegetal klopt niet'
      }
    }
  }
  return 'Gelieve een geldige rekeningnummer op te geven'
}

export const isValidVCode = (value: string): string => {
  const regex = /^v\d{7}$/i
  return regex.test(value) ? null : 'Gelieve een geldige vCode op te geven'
}

function mod97(value) {
  let checksum = value.slice(0, 2),
    fragment
  for (let offset = 2; offset < value.length; offset += 7) {
    fragment = String(checksum) + value.substring(offset, offset + 7)
    checksum = parseInt(fragment, 10) % 97
  }
  return checksum
}

export const isEmailError = (value: string): string => {
  if (value) {
    const match = /^[\w.% '!#$&*/=?^_`{|}~+-]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,10}$/.exec(!value ? '' : value)
    if (match) {
      return null
    } else {
      return 'Gelieve een geldig e-mailadres op te geven'
    }
  } else {
    return 'Gelieve een geldig e-mailadres op te geven'
  }
}

export const isValidDateError = (value: string): string => {
  if (moment(value, 'DD.MM.YYYY', true).isValid()) {
    return null
  } else {
    return 'Gelieve een geldige datum in te geven "DD.MM.JJJJ"'
  }
}

export const isValidDateByFormatError = (value: string, error, format = 'DD.MM.YYYY'): string => {
  if (moment(value, format, true).isValid()) {
    return ''
  } else {
    return error
  }
}

export const isValidDateInputFieldsError = (value: string) => {
  const match = /^([0-9]{0}|[0-9]{4})-([0-9]{0,2})-([0-9]{0,2})$/.exec(value)
  if (match) {
    const year = Number(match[1])
    let month = Number(match[2])
    let day = Number(match[3])

    if (day === 0) {
      day = 1
      if (month === 0) {
        month = 1
        if (year === 0) {
          return null
        }
      }
    }

    if (moment(replaceNansByZeros(null, year.toString(), month.toString(), day.toString()), 'YYYY-MM-DD', true).isValid()) {
      return null
    }
  }

  return 'Gelieve een geldige datum in te geven "DD MM YYYY", "MM YYYY", "YYYY"'
}

export const isValidDateFormatDayMonthYear = (value: string): string => {
  if (moment(value, 'DD.MM.YYYY', true).isValid()) {
    return null
  } else {
    return 'Gelieve een geldige datum in te geven "dd.mm.jjjj"'
  }
}

export const replaceNansByZeros = (match: string, year: string, month: string, day: string) => {
  year = year || '0000'
  day = day ? '0'.repeat(2 - day.length) + day : '00'
  month = month ? '0'.repeat(2 - month.length) + month : '00'

  return [year, month, day].join('-')
}

export const isUntilDateError = (value: string, element: HTMLInputElement): string => {
  if (element && element.id.startsWith('dateUntil')) {
    const idArray = element.id.split('_')
    const searchArray = idArray
    searchArray[0] = 'dateSince'
    const sinceDate = (document.getElementById(searchArray.join('_')) as HTMLInputElement).value

    if (sinceDate && moment(sinceDate, 'DD.MM.YYYY').diff(moment(value, 'DD.MM.YYYY')) >= 0) {
      return 'De einddatum moet na de begindatum liggen'
    } else {
      return null
    }
  }
  return null
}

export const noFutureDateError = (value: string, format = 'DD.MM.YYYY'): string => {
  if (moment().diff(moment(value, format)) < 0) {
    return 'Deze datum kan niet in de toekomst liggen'
  }
  return null
}

export const noFutureDateErrorByLocale = (value: string, format = 'DD.MM.YYYY', locale: string = defaultLocale): string => {
  if (moment().diff(moment(value, format)) < 0) {
    return translate('general.validation.futureDate', locale)
  }
  return ''
}

export const noDateBeforeError = (value: string, dateBefore: string, format = 'DD.MM.YYYY'): string => {
  const before = moment(dateBefore, format)
  if (moment(value, format).diff(before) < 0) {
    return `Deze datum moet na ${before.format('DD.MM.YYYY')} liggen`
  }
  return null
}

export const noDateAfterError = (value: string, dateAfter: string, format = 'DD.MM.YYYY'): string => {
  const after = moment(dateAfter, format)
  if (moment(value, format).diff(after) > 0) {
    return `Deze datum moet voor of samen vallen met ${after.format('DD.MM.YYYY')}`
  }
  return null
}

export const mustBePastDate = (value: string): string => {
  if (moment().subtract(1, 'days').diff(moment(value, 'YYYY-MM-DD')) < 0) {
    return 'Deze datum moet in het verleden liggen'
  }
  return null
}

export const mustBeValidDateAndTimeByLocale = (value: string, locale: string = defaultLocale): string => {
  const dateValue = value ? value.trim() : null
  if (dateValue) {
    const date = moment(dateValue, 'DD.MM.YYYY', true)
    const dateTime = moment(dateValue, 'DD.MM.YYYY HH:mm', true)
    if (!date.isValid() && !dateTime.isValid()) {
      const format = translate('general.placeholder.dateTime', locale)
      return translate('general.validation.validDate', locale, { format })
    }
  }
  return null
}

export const dayMonthRequired = (value) => {
  if (!value['month'] && value['day']) {
    return translate('general.validation.dayMonthRequired')
  }
  return ''
}

export const monthValidation = (value) => {
  if (value['month'] && !value['day']) {
    if (parseInt(value['month']) > 12) {
      return translate('general.validation.validMonth')
    }
  }
  return ''
}

export const yearRequired = (value) => {
  if ((value['day'] || value['month']) && !value['year']) {
    return translate('general.validation.yearRequired')
  }
  return ''
}

export const fullDateValidation = (value) => {
  const year = parseInt(value['year'], 10)
  const month = parseInt(value['month'], 10)
  const day = parseInt(value['day'], 10)

  if (year && month && day) {
    return isValidDateByFormatError(
      `${value['day']}.${value['month']}.${value['year']}`,
      translate('general.validation.validDate', null, { format: translate('general.placeholder.date') }),
    )
  }
  return ''
}

function sanitizeInput(input: string) {
  const meta_chars = ['+', '"', '<', '>', ';', '/', '(', ')']
  input = input.replaceAll('\\\\\\\\', '\\\\\\\\')
  input = input.replaceAll('^#', '\\\\\\\\#')
  input = input.replaceAll('^ | $', '\\\\\\\\ ')
  for (let i = 0; i < meta_chars.length; i++) {
    input = input.replaceAll(meta_chars[i], ' ' + meta_chars[i])
  }
  return input
}

export const isCapakeyError = (value: string): string => {
  if (value) {
    const match = /([0-9]{5})([a-zA-Z]{1})([0-9]{4})[/]([0-9]{2})([a-zA-Z]|['_']{1})([0-9]{3})/g.exec(!value ? '' : value)
    if (match) {
      return null
    } else {
      return 'Gelieve een volledige capakey op te geven'
    }
  } else {
    return 'Gelieve een geldige capakey op te geven'
  }
}

export const isFilenameLengthError = (value: File[], locale: string = defaultLocale): string => {
  if (value) {
    const characterLength = 128
    const tooLongName = value.find((file) => file.name.length > characterLength)

    if (tooLongName) {
      return translate('general.validation.fileNameTooLong', locale)
    }
    return null
  }
}

export const fiche60RequiredFields = (value: any, internalDataObject: any): string => {
  if (value && value === internalDataObject.jaar) {
    if (!internalDataObject.kantoorNummer || !internalDataObject.volgNummer || !internalDataObject.typeFiche || !internalDataObject.goedNummer) {
      return 'Vul alle velden van Fiche 60 in of laat alle velden leeg.'
    }
  } else if (value && value === internalDataObject.kantoorNummer) {
    if (!internalDataObject.jaar || !internalDataObject.volgNummer || !internalDataObject.typeFiche || !internalDataObject.goedNummer) {
      return 'Vul alle velden van Fiche 60 in of laat alle velden leeg.'
    }
  } else if (value && value === internalDataObject.volgNummer) {
    if (!internalDataObject.jaar || !internalDataObject.kantoorNummer || !internalDataObject.typeFiche || !internalDataObject.goedNummer) {
      return 'Vul alle velden van Fiche 60 in of laat alle velden leeg.'
    }
  } else if (value && value === internalDataObject.typeFiche) {
    if (!internalDataObject.jaar || !internalDataObject.kantoorNummer || !internalDataObject.volgNummer || !internalDataObject.goedNummer) {
      return 'Vul alle velden van Fiche 60 in of laat alle velden leeg.'
    }
  } else if (value && value === internalDataObject.goedNummer) {
    if (!internalDataObject.jaar || !internalDataObject.kantoorNummer || !internalDataObject.volgNummer || !internalDataObject.typeFiche) {
      return 'Vul alle velden van Fiche 60 in of laat alle velden leeg.'
    }
  } else {
    return null
  }
}
